import Divider from "./Divider";

export default function TextAndImageSection({
  sectionName,
  containerName,
  containerStyle,
  title,
  text,
  imgUrl,
  btnLink,
  dividerMargin,
}) {
  return (
    <div className={`${sectionName}`}>
      <div
        className={`${containerName}-container my-[7%] md:my-0 md:justify-evenly md:items-center md:flex px-[20px] md:p-[50px_30px_0px_30px] ${containerStyle}`}
      >
        <div className="md:w-[36%] mb-[30px] md:mb-0">
          <h3 className="text-[24px] md:text-[34px] pb-[2%] leading-[32px] md:leading-[41px] font-bold text-[#DA2128] my-[0.67em]">
            {title}
          </h3>

          <p className="leading-[20px] text-[#373737] pb-[1%] text-[16px] mb-5 font-open">
            {text}
          </p>

          {btnLink && (
            <div className="md:inline-block btn-cont">
              <a
                href={btnLink}
                className="bg-[#DA2128] text-white text-center rounded-[3px] inline-block p-[10px_15px] text-[14px] font-bold leading-[1.15]"
              >
                Get Started
              </a>
            </div>
          )}
        </div>

        <div className="w-full img-cont md:w-auto">
          <img className="w-full md:w-auto" src={imgUrl}></img>
        </div>
      </div>

      <Divider marginStyle={dividerMargin} />
    </div>
  );
}
